// extracted by mini-css-extract-plugin
module.exports = {"context_menu":"index_context_menu__3yAz1","contextMenu":"index_context_menu__3yAz1"};